import { Version } from '../../version/version';
import { ServerInfoDTO } from '../dto/serverinfo.dto';

export class ServerInfo {
  public cloudVersion: Version;
  public hasLiteserver: boolean;
  public liteServerVersion: Version;

  public static fromDTO(serverInfoDTO: ServerInfoDTO): ServerInfo {
    const serverInfo: ServerInfo = new ServerInfo();
    serverInfo.cloudVersion = new Version(
      serverInfoDTO.serverVersion.major || 0,
      serverInfoDTO.serverVersion.minor || 0,
      serverInfoDTO.serverVersion.release || 0
    );

    serverInfo.hasLiteserver = serverInfoDTO.hasLiteServer;

    if (serverInfoDTO.hasLiteServer) {
      serverInfo.liteServerVersion = new Version(
        serverInfoDTO.liteServerVersion.major || 0,
        serverInfoDTO.liteServerVersion.minor || 0,
        serverInfoDTO.liteServerVersion.release || 0
      );
    }

    return serverInfo;
  }
}
